export default "__VITE_ASSET__BSVRiTTo__"